// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lang-switcher {
  position: relative;
  display: inline-block;
}

.lang-switcher__trigger {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.6rem;
  background: transparent;
  color: inherit;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: var(--radius-pill);
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  transition:
    background var(--transition),
    color var(--transition),
    border-color var(--transition);
}

.lang-switcher__trigger:hover {
  color: var(--interactive-hover);
  border-color: var(--interactive-hover);
}

.lang-switcher__trigger:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.lang-switcher__chevron {
  font-size: 0.7rem;
  line-height: 1;
  transition: transform var(--transition);
}

.lang-switcher__chevron--open {
  transform: rotate(180deg);
}

.lang-switcher__flag {
  font-size: 1rem;
  line-height: 1;
}

.lang-switcher__list {
  position: absolute;
  top: calc(100% + 0.4rem);
  right: 0;
  min-width: 9rem;
  list-style: none;
  background: var(--bg-surface);
  color: var(--text-primary);
  border-radius: var(--radius-md, 0.5rem);
  box-shadow: var(--shadow);
  padding: 0.35rem;
  z-index: 60;
}

.lang-switcher__option {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.45rem 0.6rem;
  border-radius: var(--radius-sm);
  font-size: 0.85rem;
  text-align: left;
  color: inherit;
  background: transparent;
  transition:
    background var(--transition),
    color var(--transition);
}

.lang-switcher__option:hover {
  background: var(--interactive);
  color: var(--interactive-fg);
}

.lang-switcher__option:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -2px;
}

.lang-switcher__option--active {
  font-weight: 700;
  color: var(--interactive);
}

.lang-switcher__option--active:hover {
  color: var(--interactive-fg);
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/LanguageSwitcher/LanguageSwitcher.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,2CAA2C;EAC3C,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB;;;kCAGgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,uCAAuC;EACvC,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB;;2BAEyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".lang-switcher {\n  position: relative;\n  display: inline-block;\n}\n\n.lang-switcher__trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.35rem 0.6rem;\n  background: transparent;\n  color: inherit;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  border-radius: var(--radius-pill);\n  font-size: 0.8rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  transition:\n    background var(--transition),\n    color var(--transition),\n    border-color var(--transition);\n}\n\n.lang-switcher__trigger:hover {\n  color: var(--interactive-hover);\n  border-color: var(--interactive-hover);\n}\n\n.lang-switcher__trigger:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n\n.lang-switcher__chevron {\n  font-size: 0.7rem;\n  line-height: 1;\n  transition: transform var(--transition);\n}\n\n.lang-switcher__chevron--open {\n  transform: rotate(180deg);\n}\n\n.lang-switcher__flag {\n  font-size: 1rem;\n  line-height: 1;\n}\n\n.lang-switcher__list {\n  position: absolute;\n  top: calc(100% + 0.4rem);\n  right: 0;\n  min-width: 9rem;\n  list-style: none;\n  background: var(--bg-surface);\n  color: var(--text-primary);\n  border-radius: var(--radius-md, 0.5rem);\n  box-shadow: var(--shadow);\n  padding: 0.35rem;\n  z-index: 60;\n}\n\n.lang-switcher__option {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.45rem 0.6rem;\n  border-radius: var(--radius-sm);\n  font-size: 0.85rem;\n  text-align: left;\n  color: inherit;\n  background: transparent;\n  transition:\n    background var(--transition),\n    color var(--transition);\n}\n\n.lang-switcher__option:hover {\n  background: var(--interactive);\n  color: var(--interactive-fg);\n}\n\n.lang-switcher__option:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: -2px;\n}\n\n.lang-switcher__option--active {\n  font-weight: 700;\n  color: var(--interactive);\n}\n\n.lang-switcher__option--active:hover {\n  color: var(--interactive-fg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
